<template>
  <div>
    <div class="row">
      <div class="col">
        <h5>Title and category of abstract</h5>
        <div>
          Please enter a title and choose a category for your abstract
        </div>
      </div>
    </div>
    <div class="row mt-3">
      <div class="col">
        <div class="alert alert-info mb-1">
          <div class="row">
            <div class="col-1 d-flex">
              <icon :icon="['fad', 'exclamation']" class="my-auto fa-2x"/>
            </div>
            <div class="col my-auto">
              Please note that when entering the title of your abstract, the system will automatically check if this
              abstract has already been submitted before.
            </div>
          </div>
        </div>
      </div>
    </div>
    <hr>
    <div class="row">
      <div class="col">
        <div class="form-group">
          <label for="title" class="font-weight-bold text-primary">Title:</label>
          <small id="titleHelp" class="form-text text-muted">Max. 110 characters.</small>
          <input type="text" class="form-control" id="title" aria-describedby="Enter Title" v-model="title" size="110">
          <div v-if="error && error.title && error.title.length > 0" class="mt-1">
            <ul class="alert alert-danger">
              <li v-for="(errordetail, index) in error.title" v-bind:key="index">{{ errordetail }}</li>
            </ul>
          </div>
        </div>
      </div>
    </div>


    <div class="row mt-3">
      <div class="col-sm">
        <div class="card h-100">
          <div class="card-body">
            <h5 class="card-title text-success" style="text-align: center;">Advocacy and policy report</h5>
          </div>
          <div class="card-footer bg-transparent border-0 d-flex">
            <button class="btn btn-success mx-auto" v-on:click="checkAbstractTitle(1)">Select</button>
          </div>
        </div>
      </div>
      <div class="col-sm">
        <div class="card h-100">
          <div class="card-body">
            <h5 class="card-title text-success" style="text-align: center;">Scientific study</h5>
          </div>
          <div class="card-footer bg-transparent border-0 d-flex">
            <button class="btn btn-success mx-auto" v-on:click="checkAbstractTitle(2)">Select</button>
          </div>
        </div>
      </div>
      <div class="col-sm">
        <div class="card h-100">
          <div class="card-body">
            <h5 class="card-title text-success" style="text-align: center;">Fundraising reports</h5>
          </div>
          <div class="card-footer bg-transparent border-0 d-flex">
            <button class="btn btn-success mx-auto" v-on:click="checkAbstractTitle(3)">Select</button>
          </div>
        </div>
      </div>
    </div>

  </div>
</template>

<script>
import {mapState, mapGetters, mapActions} from 'vuex'

export default {
  name: "AbstractType",
  data() {
    return {
      submitted: false,
      title: "",
      error: {}
    };
  },
  methods: {
    ...mapActions([
      'CREATE_ABSTRACT', 'UPDATE_REFERENCE', 'VALIDATE_FREE'
    ]),
    async checkAbstractTitle(type) {
      let template = {};
      template.rules = {
        "rules": {
          "title": "required|unique:App\\Models\\psAbstract,title|max:110"
        },
        "attributes": {
          "title": "Title"
        }
      };
      template.data = {"title": this.title};
      await this.VALIDATE_FREE(template).then((result) => {
        this.error = {};
        this.newAbstract(type)
      }).catch((error) => {
        this.$noty.error(this.wording[0].notify.validation_error);
        this.error = error.response.data;
      })

    },
    newAbstract(type) {

      if (this.submitted === true) {
        return false;
      }
      this.submitted = true;
      let template = {
        "user_id": this.user.id,
        "setting_submission_id": 1,
        "reference_number": this.getSettings(1).reference_number,
        "content": {},
        "status_id": 1
      };
      template.title = this.title;
      template.type_id = type;
      if (type == 1) {
        template['content'].text = "Background and context: <br>Aim: <br>Strategy / Tactics: <br>Programme / Policy process: <br>Outcomes: <br>What was learnt: (if relevant, please also detail here the potential of replicability)",
            template['content'].category_name = "Advocacy and policy report"
      }
      if (type == 2) {
        template['content'].text = "Background: <br>Aim: <br>Methods: <br>Results: <br>Conclusion:",
            template['content'].category_name = "Scientific study"
      }
      if (type == 3) {
        template['content'].text = "Amount raised: <br>Background and context: <br>Aim: <br>Strategy / Tactics: <br>Programme process: <br>Costs and returns: <br>What was learnt: (if relevant, please also detail here the potential of replicability)",
            template['content'].category_name = "Fundraising reports"
      }
      this.CREATE_ABSTRACT(template).then((response) => {
        let reference_id = ("00000" + response.data.id).slice(-5);
        this.UPDATE_REFERENCE({
          "abstract_id": response.data.id,
          "reference_number": response.data.reference_number + reference_id
        }).then((responseReference) => {
          this.$noty.success('Save was successful');
          this.$router.push('abstract/' + response.data.id + '/dynamic/' + this.getFirstCurrentPage(1).id)
        }).catch((error) => {
          this.$noty.error('Save was <strong>not</strong> successful');
        });
      }).catch((error) => {
        this.$noty.error('Save was <strong>not</strong> successful');
      });
    }
  },
  computed: {
    ...mapState([
      'wording', 'user'
    ]),
    ...mapGetters([
      'getSettings', 'getFirstCurrentPage'
    ]),
  },
}
</script>

<style scoped>

</style>
